import script from "./BetBoosterCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBoosterCardHeader.vue?vue&type=script&setup=true&lang=js"

import "./BetBoosterCardHeader.vue?vue&type=style&index=0&id=5881530e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5881530e"]])

export default __exports__